
export * from "./patients";
export * from "./profession";
export * from "./type-patient";
export * from "./admissions";
export * from "./etat-admission";
export * from "./service";
export * from "./type-admission";
export * from "./personne";
export * from "./pages";
export * from "./pays";
export * from "./poste";
export * from "./prescription-dialyse";
export * from "./prescription-dialyse-journalier";
export * from "./prescription-analyse";
export * from "./planning-dialyse";
export * from "./planning-fiche";
export * from "./voie-dabord";
export * from "./voie-dabord-aiguilleArtere";
export * from "./voie-dabord-aiguilleVeine";
export * from "./voie-dabord-catethere";
export * from "./voie-dabord-fav";
export * from "./voie-dabord-ponction";
export * from "./voie-dabord-ponction-ligne";
export * from "./voie-dabord-prothese";
export * from "./voie-dabord-type";
export * from "./voie-dabord-type-anesthesie";
export * from "./seance-type-traitement";
export * from "./seance-sol-restitution";
export * from "./seance-modele";
export * from "./seance-generateur";
export * from "./seance-dialyseur";
export * from "./plan-observation";
export * from "./activity-log";
export * from "./users";
export  * from "./programmation-lot-dialyse"



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/models/index.ts